import AuthLayout from '@/app/layout/authLayout'
import { LoginForm } from '@/app/entities/auth/ui/login/Form'

export const LoginPage = () => {
    return (
        <AuthLayout>
            <LoginForm />
        </AuthLayout>
    )
}
